angular
	.module('pratiche.components', [])
	.component('pratiche', {
		templateUrl: 'ng/components/pratiche/pratiche.html',
		bindings: {
			/** Input data **/
			titolo:'<',
			preventiviAccettati : '<',
			contrattiPervenutiAttivi: '<',
			contrattiStipulati: '<',
			contrattiTotali: '<',

			importoPreventiviAccettati: '<',
			importoContrattiPervenutiAttivi: '<',
			importoContrattiStipulati: '<',
			importoContrattiTotali: '<'

		},
		controllerAs: 'praticheCtrl',
		controller: function praticheCtrl() {

			var self = this;

			self.$onInit = function () {
				
			}
			
		}
	});
